module.exports = __webpack_public_path__ + "img/searching.5466e295.gif";